import "./CharacterPortrait.css";
import type { CSSProperties } from "react";
import type { ICharacterAvatarProps, CharacterAvatarSize, CharacterStatus } from "../../../models/ICharacter";
import { getCharacterAvatarTokens } from "../CharacterTokens";

function shouldRenderStatusBadge(status: CharacterStatus | undefined, showStatusBadge: boolean | undefined): boolean {
    if (showStatusBadge === false) {
        return false;
    }

    if (!status || status === "normal") {
        return false;
    }

    return true;
}

export function CharacterAvatar(props: ICharacterAvatarProps): JSX.Element {
    const size: CharacterAvatarSize = props.size ?? "md";
    const status: CharacterStatus = props.status ?? "normal";

    const t = getCharacterAvatarTokens(size);

    const style: CSSProperties = {
        width: `${t.diameterPx}px`,
        height: `${t.diameterPx}px`,
        borderWidth: `${t.ringPx}px`,
        ["--cp-badge-diameter" as any]: `${t.badgeDiameterPx}px`,
        ["--cp-badge-ring" as any]: `${t.badgeRingPx}px`,
        ["--cp-badge-offset" as any]: `${t.badgeOffsetPx}px`,
    };

    const canClick = Boolean(props.onClick);
    const ariaLabel = props.name ? `${props.name}, level ${props.level}` : `Level ${props.level}`;

    const renderStatus = shouldRenderStatusBadge(status, props.showStatusBadge);

    return (
        <div
            className={`characterAvatar ${canClick ? "clickable" : ""}`}
            style={style}
            role={canClick ? "button" : undefined}
            aria-label={ariaLabel}
            //title={props.title ?? props.name}     // A ToolTip shows name if available
            onClick={props.onClick}
        >
            {/* Inner clip keeps the portrait clean while outer frame allows badges to overflow */}
            <div className="characterAvatarClip">
                {props.imageUrl ? (
                    <img className="characterAvatarImage" src={props.imageUrl} alt={props.name ?? "Character portrait"} />
                ) : (
                    <div className="characterAvatarFallback" aria-hidden="true" />
                )}
            </div>

            {/* Status Badge (bottom-left) */}
            {renderStatus ? (
                <div className={`characterAvatarStatusBadge status-${status}`} aria-hidden="true" title={status} />
            ) : null}

            {/* Level Badge (bottom-right) – ALWAYS shown (per spec) */}
            <div className="characterAvatarLevelBadge" aria-hidden="true">
                {props.level}
            </div>
        </div>
    );
}
